import React from 'react';
import Icon from '../../../components/AppIcon';

const ProductionStatusCard = ({ title, stages, totalJobs }) => {
  const getStatusColor = (status) => {
    const colors = {
      'In Progress': 'bg-warning text-warning-foreground',
      'Completed': 'bg-success text-success-foreground',
      'Pending': 'bg-error text-error-foreground',
      'Queue': 'bg-secondary text-secondary-foreground'
    };
    return colors[status] || 'bg-muted text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1 h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Factory" size={16} />
          <span>{totalJobs} Jobs</span>
        </div>
      </div>

      <div className="space-y-4 ">
        {stages.map((stage, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className={`w-3 h-3 rounded-full ${getStatusColor(stage.status).split(' ')[0]}`}></div>
              <div>
                <p className="font-medium text-foreground">{stage.name}</p>
                <p className="text-sm text-muted-foreground">{stage.operator}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="font-semibold text-foreground">{stage.count}</p>
              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(stage.status)}`}>
                {stage.status}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductionStatusCard;